export default __webpack_public_path__ + "static/media/nachocheese-image.e22c3098.webp";